import { getApp, getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
};

import { initializeFirestore } from "firebase/firestore";

// Initialize Firebase
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
const auth = getAuth(app);

// Check if running in a performance testing environment to fallback to long-polling
const isTestEnv = typeof window !== "undefined" && (
    /Lighthouse|Google-PageSpeed|Chrome-Lighthouse|SpeedIns|headless|PageSpeed|WebPageTest/i.test(navigator.userAgent) ||
    navigator.webdriver
);

const db = isTestEnv 
    ? initializeFirestore(app, { experimentalForceLongPolling: true })
    : getFirestore(app);

const storage = getStorage(app);

export { app, auth, db, storage };
